// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { accountOverviewStyles } from "@conklin/App/Widgets/MyAccount/AccountOverview";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, linkArrowStyle, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

accountOverviewStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        justify-content: space-between;
        padding-bottom: 16px;
    `,
};

accountOverviewStyles.greetingTitle = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin: 0 24px 0 0;
        ${xScreen("lte", "sm")} {
            flex: 0 0 100%;
            margin: 0 0 8px 0;
        }
    `,
};

accountOverviewStyles.customerNumberLabel = {
    variant: "h6",
    forwardAs: "span",
    weight: fontConfig.weight.regular,
    css: css`
        white-space: nowrap;
        margin-bottom: 0;
        display: inline;
    `,
};

accountOverviewStyles.customerNumberValue = {
    variant: "h6",
    forwardAs: "span",
    css: css`
        margin-bottom: 0;
        display: inline;
    `,
};

accountOverviewStyles.link = linkArrowStyle("small", {
    css: css`
        margin-left: auto;
    `,
});

accountOverviewStyles.accountMessage = {
    size: 12,
    lineHeight: "15px",
    css: css`
        flex: 0 0 100%;
        margin-top: 8px;
        ${({ dashboard }: any) => dashboard && "margin-top: 16px"};

        ${({ dashboard, displayOverviewMessage }: any) => {
            if (!displayOverviewMessage) {
                return dashboard
                    ? css`
                          display: none;
                      `
                    : css`
                          visibility: hidden;
                      `;
            }
            return null;
        }}
    `,
};
